import React from 'react'
import { connect } from 'react-redux'
import { Icon, Button, Header, Form, Modal } from 'semantic-ui-react'
import moment from 'moment'

import firebase from 'firebase/app'

import RestaurantActions from '../../../reducers/restaurantReducer'

import DateField from '../fields/dateField'

class DiscountForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    startAt: Number(
      moment()
        .startOf('day')
        .format('x')
    ),
    endAt: Number(
      moment()
        .add(3, 'day')
        .endOf('day')
        .format('x')
    ),
    loading: false,
  }

  componentDidMount() {
    const { branch } = this.props

    if (branch.temporary_closed) {
      this.setState({
        startAt: branch.temporary_closed.start_at,
        endAt: branch.temporary_closed.end_at,
      })
    }
  }

  setStateAsync = state => new Promise(resolve => this.setState(state, resolve))

  onSave = async e => {
    e.preventDefault()

    const { onClose, branch, storeId, setBranch } = this.props
    const { startAt, endAt } = this.state

    const temporaryClosed = {
      start_at: Number(
        moment(startAt)
          .startOf('day')
          .format('x')
      ),
      end_at: Number(
        moment(endAt)
          .endOf('day')
          .format('x')
      ),
    }

    await this.setStateAsync({ loading: true })

    const err = await firebase
      .database()
      .ref(`restaurants/${storeId}/branches/${branch.key}/temporary_closed`)
      .update(temporaryClosed)

    await this.setStateAsync({ loading: false })

    if (err) {
      alert('Fail to set temporary close to this branch.')
    } else {
      setBranch(storeId, branch.key, { ...branch, temporary_closed: temporaryClosed })
      onClose()
    }
  }

  onRemove = async () => {
    const { onClose, branch, storeId, setBranch } = this.props
    await this.setStateAsync({ loading: true })

    const err = await firebase
      .database()
      .ref(`restaurants/${storeId}/branches/${branch.key}/temporary_closed`)
      .remove()

    await this.setStateAsync({ loading: false })

    if (err) {
      alert('Fail to remove temporary closed.')
    } else {
      setBranch(storeId, branch.key, { ...branch, temporary_closed: null })
      onClose()
    }
  }

  render() {
    const { startAt, endAt, loading } = this.state
    const { visible, onClose } = this.props

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content="Temporary Close" />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form
            onSubmit={this.onSave}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={loading}
          >
            <Form.Group widths="equal">
              <DateField
                label="Branch will be close from"
                onChange={value => this.setState({ startAt: value })}
                value={startAt}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <DateField
                label="Branch will be open after"
                onChange={value => this.setState({ endAt: value })}
                value={endAt}
              />
            </Form.Group>
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            icon
            floated="left"
            color="red"
            onClick={this.onRemove}
            loading={loading}
            disabled={loading}
          >
            <Icon name="delete" /> Remove
          </Button>

          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapDispatch = {
  setBranch: RestaurantActions.setBranchData,
}

export default connect(
  null,
  mapDispatch
)(DiscountForm)



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/temporaryClosedForm.js